import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FolderSimple } from "@phosphor-icons/react";

export default function MoveClientDialog({
  client,
  folders,
  targetFolderId,
  setTargetFolderId,
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog
      open={!!client}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
    >
      <DialogContent
        className="bg-[#171717] border-[#262626] text-white max-w-sm"
        data-testid="move-client-dialog"
      >
        <DialogHeader>
          <DialogTitle
            className="font-bold tracking-tight uppercase"
            style={{ fontFamily: "Barlow Condensed, sans-serif" }}
          >
            SPOSTA CLIENTE
          </DialogTitle>
        </DialogHeader>
        <div className="py-2">
          {client && (
            <div className="flex items-center gap-3 mb-4 p-3 bg-[#0A0A0A] rounded-lg border border-[#1A1A1A]">
              <div className="w-9 h-9 rounded-full bg-[#007AFF]/20 flex items-center justify-center text-[#007AFF] font-bold text-sm">
                {client.first_name?.charAt(0)?.toUpperCase()}
                {client.last_name?.charAt(0)?.toUpperCase()}
              </div>
              <div>
                <p className="text-sm font-medium text-white">
                  {client.first_name} {client.last_name}
                </p>
                <p className="text-xs text-zinc-500">
                  Attuale:{" "}
                  {client.folder_id
                    ? folders.find((f) => f.id === client.folder_id)?.name || "—"
                    : "Senza cartella"}
                </p>
              </div>
            </div>
          )}
          <Label className="text-zinc-400 text-xs uppercase tracking-wider">
            Cartella di destinazione
          </Label>
          <Select value={targetFolderId} onValueChange={setTargetFolderId}>
            <SelectTrigger
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="move-folder-select"
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#171717] border-[#262626]">
              <SelectItem value="none" className="text-white">
                Senza cartella
              </SelectItem>
              {folders.map((f) => (
                <SelectItem key={f.id} value={f.id} className="text-white">
                  <span className="flex items-center gap-2">
                    <FolderSimple size={14} className="text-[#D4FF00]" />
                    {f.name}
                  </span>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            className="border-[#262626] text-zinc-300 hover:bg-[#1A1A1A]"
            data-testid="move-cancel-button"
          >
            Annulla
          </Button>
          <Button
            onClick={onConfirm}
            className="bg-[#007AFF] hover:bg-[#3395FF] text-white"
            data-testid="move-confirm-button"
          >
            Sposta
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
